import React, {Component} from 'react'
import {connect} from 'react-redux'
import {buildUrlFromParams} from '../../common/functions/url'
import WithAjax from '../../common/helpers/WithAjax'
import {clearVoiceTestCandidateSearchFields, validateVoiceTestCandidateSearchField} from '../../../actions/pages/voice-test-page'
import VoiceTestCandidateSearchResult from './VoiceTestCandidateSearchResult'
import SingleLineSearchForm from '../../common/form/SingleLineSearchForm'
import InputField from '../../common/form/InputField'

class VoiceTestCandidateSearch extends Component {
  constructor() {
    super()
    this.onSearch = this.onSearch.bind(this)

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.clearVoiceTestCandidateSearchFields();
  }

  onSearch() {
    var searchTextField = this.props.voiceTestCandidateSearchFields.find((el) => {
      return el.name === 'SearchText';
    });

    let url = buildUrlFromParams(
      'skillVendors',
      {
        searchText: searchTextField.value,
        skillTypes: this.props.skillType
      });

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].Id;
      });
      this.setState({
        items: data
      })
    });
  }

  render() {
    let fields = this.props.voiceTestCandidateSearchFields;

    return (
      <div>
        <SingleLineSearchForm fields={fields} onSearch={this.onSearch}>
            <div className="col-5">
              <InputField field={fields[0]} validate={this.props.validateVoiceTestCandidateSearchField} />
            </div>
        </SingleLineSearchForm>
        <VoiceTestCandidateSearchResult items={this.state.items} voiceTestId={this.props.voiceTestId} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  voiceTestCandidateSearchFields: state.voiceTestCandidateSearch.fields
})
const mapDispatchToProps = dispatch => ({
  clearVoiceTestCandidateSearchFields() { dispatch(clearVoiceTestCandidateSearchFields()) },
  validateVoiceTestCandidateSearchField(value, field) { dispatch(validateVoiceTestCandidateSearchField(value, field)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(VoiceTestCandidateSearch))
